import { render, staticRenderFns } from "./key-value-unit.vue?vue&type=template&id=82bddca4&scoped=true"
import script from "./key-value-unit.vue?vue&type=script&lang=js"
export * from "./key-value-unit.vue?vue&type=script&lang=js"
import style0 from "./key-value-unit.vue?vue&type=style&index=0&id=82bddca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bddca4",
  null
  
)

export default component.exports